RivalIQ.apps.AdsInsights.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const BreadcrumbPartMaxLength = 60;

    views.Breadcrumbs = Marionette.ItemView.mixin({
        template: '#adsInsightsBreadcrumbTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        behaviors: {
            Titles: RivalIQ.behaviors.Titles
        },

        serializeData: function () {
            const me = this;

            const adObject = me.getOption('adObject');
            const showAccountName = me.getOption('showAccountName');
            const breadcrumbs = App.utils.calculateBreadcrumbsForAdObject(me.dashboardModel, adObject, {
                showAccountName: showAccountName
            });

            return {
                breadcrumbs: breadcrumbs,
                breadcrumbPartMaxLength: BreadcrumbPartMaxLength,
                linkLastBreadcrumb: Boolean(me.getProp('instanceId')),
                noLinks: Boolean(me.getOption('noLinks'))
            };
        },

        templateHelpers: function () {
            return _.extend({
                s: s
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        }
    });
}, window.s);
